module.exports = __webpack_public_path__ + "img/22.34f6c63b.png";